import {useEffect, useState} from 'react';
import {genericErrorHasOccurred} from '../../../actions/generic-error/action-creators';
import {getCardDetails} from '../../../actions/cybersource-confirmation/browser';
import {areVendorsLoaded, areVendorsReady} from '../CyberSource/cybersource.selectors';

export const useCybersourceConfirmation = ({
    paymentSessionId,
    languageCode,
    availableLanguageCodes,
    csrfToken,
    dispatch,
    actions,
    initCardDetails,
    initError,
    cyberSourceData
}) => {
    const [cardDetails, setCardDetails] = useState(initCardDetails);
    const [error, setError] = useState(initError);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isCardinalLoading, setIsCardinalLoading] = useState(true);

    const catchError = err => {
        dispatch(genericErrorHasOccurred(true));

        setError(err);
    };

    useEffect(() => {
        if (!cardDetails && !error) {
            getCardDetails({languageCode, paymentSessionId})
                .then(setCardDetails)
                .catch(catchError);
        }
    }, [cardDetails, error, languageCode, setError]);

    useEffect(() => {
        let unsubcribeCardinal;
        if (!areVendorsLoaded({cyberSourceData})) {
            actions.loadCyberSourceInitAndSetupCardinal({languageCode, paymentSessionId})
                .then(unsubscribe => {
                    unsubcribeCardinal = unsubscribe;
                });
        } else {
            unsubcribeCardinal = actions.setupCardinal(paymentSessionId);
        }

        return () => unsubcribeCardinal();
    }, []);

    const onSubmit = securityCode => {
        setIsSubmitting(true);

        const shouldUseSavedCard = true;
        const registrationId = null;

        return actions.startAuthorizationSavedCard(
            csrfToken,
            languageCode,
            availableLanguageCodes,
            shouldUseSavedCard,
            registrationId,
            securityCode
        ).catch(catchError);
    };

    useEffect(() => {
        if (areVendorsReady({cyberSourceData})) {
            setIsCardinalLoading(false);
        }
    }, [cyberSourceData]);

    return {
        cardDetails,
        isCardinalLoading,
        isSubmitting,
        onSubmit
    };
};
